import { updateUser } from '@api/profile';
import useToastContext from '@contexts/ToastContext/hook';
import { Button } from '@vibTheme/components/_base/Button';
import { Image } from '@vibTheme/components/_base/Image';
import { Typography } from '@vibTheme/components/_base/Typography';
import { VibModal } from '@vibTheme/components/VibModal';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

const SHOW_DIALOG_INTERVAL = 31556952000; // 1 ano
export const PROFILE_ALERT_QUERY_PARAM = 'fromProfileAlert';

export const UpdateProfileDialog = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data } = useSession();
  const user = data?.user;
  if (!user) return null;

  const toast = useToastContext();
  const handleDismiss = async () => {
    await updateUser({ lastProfileUpdateAlertDate: new Date().toISOString() });
    toast.setContent('Obrigado! Seus dados foram confirmados 😊');
    setIsModalOpen(false);
  };

  const router = useRouter();
  const handleUpdateData = () => {
    setIsModalOpen(false);
    router.push(`/profile/personalData?${PROFILE_ALERT_QUERY_PARAM}=true`);
  };

  useEffect(() => {
    const date = new Date(user.lastProfileUpdateAlertDate || user.creationDate);
    const shouldShowAlert = Date.now() - date.getTime() > SHOW_DIALOG_INTERVAL;
    shouldShowAlert && setIsModalOpen(true);
  }, [user]);

  if (!isModalOpen) return null;

  return (
    <VibModal isOpen={isModalOpen} setIsOpen={setIsModalOpen}>
      <div className="max-w-[1000px] md:p-main">
        <div className="flex flex-col gap-main md:flex-row md:gap-[5rem]">
          <div className="relative h-[193px] md:w-[361px] md:h-[438px]">
            <Image
              src="/assets/girl-on-call.svg"
              alt="Garota no telefone"
              fill
            />
          </div>
          <div className="md:w-[330px]">
            <Typography component="h1" className="pb-main">
              Mantenha seus dados atualizados
            </Typography>
            <Typography>
              Manter seu e-mail e celular atualizados nos ajuda a garantir uma
              comunicação rápida e segura com você. <br />
              Por favor, revise os dados abaixo e atualize se for necessário:
            </Typography>
            <Typography className="font-semibold pt-main">
              📧 E-mail cadastrado: {user.email} <br />
              📱 Celular cadastrado: {user.phone}
            </Typography>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-end gap-main pt-main">
          <Button onClick={handleUpdateData}>Atualizar dados</Button>
          <Button variant="text" onClick={handleDismiss}>
            Estão corretos
          </Button>
        </div>
      </div>
    </VibModal>
  );
};
